import SlideContainer from './view';

export default SlideContainer;